import { useCallback } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import SearchbarQuoteCustomerDeciderComponent from '../../../../app/erp/screens/Logistic/QuoteParent/QuoteOrders/ModalCreateQuoteOrder/SearchBarQuoteCustomer'
import { QuoteOrderModelTypeExtended } from '../../../../app/erp/screens/Logistic/QuoteParent/QuoteOrders/ModalCreateQuoteOrder/types'
import CustomError from '../../../../baseComponents/CustomError'
import { LittleModalCreateEditChildrenFirst } from '../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../forms/FormRenderer/types'
import { OnSubmit } from '../../../../forms/TwinForm/types'
import locations from '../../../../utils/globals/locations'
import { checkIfCanCreateQuote } from '../../../../utils/globals/order/order'
import withLoading from '../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../utils/reducers/company/workingCenters'
import { getSelectedWorkingCenter } from '../../../../utils/reducers/getters'

type ModalCampaignCustomerCreateQuoteProps = ModalEditComponentProps & ReduxModalCustomerQuotesCreateConnector & {}

const ModalCampaignCustomerCreateQuote: React.FC<ModalCampaignCustomerCreateQuoteProps> = ({ userPermissions, allRowData, workingCenters, ...rest }) => {
    const { t } = useTwinTranslation()
    const { createQuote } = useModalCampaignCustomerCreateQuoteLogic()
    const workingCenter = getSelectedWorkingCenter()
    const error = checkIfCanCreateQuote(t, workingCenters?.[workingCenter?.id])
    const fields: FormRender<QuoteOrderModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'custom_name',
                    label: t('customName', 'Nombre personalizado'),
                    component: 'InputWithLabelMargin',
                },
                {
                    name: 'OrderId',
                    component: 'Custom',
                    render: () => <SearchbarQuoteCustomerDeciderComponent />
                },
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                },
                {
                    name: 'CustomerId',
                    component: 'InputHidden',
                    value: allRowData?.CustomerId
                },
                {
                    name: 'CampaignCustomerId',
                    component: 'InputHidden',
                    value: allRowData?.id
                }
            ],
        },
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/quote/createQuoteOrder'} translations={{
            title: t('newQuote', 'Nuevo presupuesto'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error}  {...{ ...rest, onSubmit: createQuote }} >
            {error ? <CustomError textError={error} className='mb-20' /> : null}
            {!workingCenters?.[workingCenter?.id]?.dictCounters && !error ? <CustomError textError={t('notFoundWorkingCenterCounterAndForceCreate', 'No se han encontrado contadores disponibles. Si decide continuar, se generará uno automáticamente.')} className='mb-20' /> : null}
        </LittleModalCreateEditChildrenFirst>)
}

const useModalCampaignCustomerCreateQuoteLogic = () => {
    const { id } = useParams()
    const navigate = useNavigate()

    const createQuote: OnSubmit = useCallback(async (res) => {
        const create = await res.json()
        return navigate(locations.quoteOrderSingle + '/' + create.id)
    }, [navigate])

    return { createQuote, id }
}

const modalCustomerQuotesCreateDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
}
const mapModalCustomerQuotesCreateConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters })
const modalCustomerQuotesCreateConnector = connect(mapModalCustomerQuotesCreateConnector, modalCustomerQuotesCreateDispatch)
type ReduxModalCustomerQuotesCreateConnector = ConnectedProps<typeof modalCustomerQuotesCreateConnector>

const modalCustomerQuotesCreateConnectLoading = withLoading(ModalCampaignCustomerCreateQuote, [{ fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ModalCustomerQuotesCreateConnect = modalCustomerQuotesCreateConnector(modalCustomerQuotesCreateConnectLoading)


export default ModalCustomerQuotesCreateConnect